import { inject, Injectable } from '@angular/core';
import { CredentialsService } from '@recipient-portal/domain';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CredentialSummary } from '../entities/speak-your-skills.model';

@Injectable({ providedIn: 'root' })
export class LerCredentialFacade {
  private readonly _credentialsService = inject(CredentialsService);

  loadCredential(uuid: string): Observable<CredentialSummary> {
    return this._credentialsService.loadCredential(uuid).pipe(
      map(({ name, issuer, course_link }) => ({
        name,
        uuid,
        issuerName: issuer.name,
        url: course_link,
      })),
    );
  }

  loadAllCredentialOptions(userId: number): Observable<CredentialSummary[]> {
    return this._credentialsService
      .loadPrivateProfile(userId)
      .pipe(
        map((profile) => (profile.credentials ?? []).map(({ name, uuid }) => ({ name, uuid }))),
      );
  }
}
